<template>
  <div id="func-3">
    <FuncionalidadeHeader
      v-if="!telaPrint"
      :customVoltar="true"
      :titulo="funcParams.dashboard.nome"
      @click="handleVoltar"
    />
    <GrupoFamiliar
      v-model="beneficiarioSelecionado"
      :style="beneficiarioSelecionado ? 'min-height: 600px' : ''"
      id-funcionalidade="3"
    >
      <div v-if="loaded">
        <el-row
          v-if="!telaPrint"
        >
          <el-col
            :lg="14"
            :md="14"
            :sm="14"
            :xl="14"
            :xs="14"
          >
            <div v-if="beneficiarioSelecionado" style="margin-top: 15px; margin-bottom: 15px;">
              <div style="font: normal normal 600 16px/22px Open Sans; letter-spacing: 0; color: #333333;">
                {{ beneficiarioSelecionado.beneficiarioDados.dadosPessoais.nome }}
              </div>
              <div style="font: normal normal normal 11px/15px Open Sans; letter-spacing: 0; color: #555555;">
                {{ beneficiarioSelecionado.contrato.descricaoContrato }}
              </div>
            </div>
            <div>
              <div
                v-if="cartaoImagem.frente"
                class="cartao-container"
                style="margin-bottom: 20px;"
              >
                <el-image
                  :src="cartaoImagem.frente.background"
                  class="cartao"
                  style="z-index: 1"
                />
                <el-image
                  :src="cartaoImagem.frente.data"
                  class="cartao"
                  style="z-index: 2"
                />
              </div>
              <div
                v-if="cartaoImagem.verso"
                class="cartao-container"
                style="position: relative;"
              >
                <el-image
                  :src="cartaoImagem.verso.background"
                  class="cartao"
                  style="z-index: 1"
                />
                <el-image
                  :src="cartaoImagem.verso.data"
                  class="cartao"
                  style="z-index: 2"
                />
              </div>
            </div>
          </el-col>
          <el-col
            :lg="10"
            :md="10"
            :sm="10"
            :xl="10"
            :xs="10"
          >
            <MenuVertical
              :columns="columnsCarencias"
              style="margin-bottom: 20px;"
              width="610px"
            />
            <DialogoCarencias
              v-model="mostrarCarencias"
              :carencias="carencias"
            />
            <MenuVertical
              :columns="columnsExport"
              style="margin-bottom: 20px;"
              width="610px"
            />
          </el-col>
        </el-row>
        <div
          v-else-if="telaPrint"
        >
          <CartaoVirtualImpressao
            :carencias="carencias"
            :cartao="cartaoImagem"
            @close="closePrint"
          />
        </div>
      </div>
    </GrupoFamiliar>
    <dialog-default
      :open.sync="showDialog"
      :showClose="handleVoltar"
      :closeOnClickModal="false"
      :title="'Alerta!'"
    >
      <el-row style="margin-bottom: 10px">
        <el-col :span="24">
          <p>{{ funcParams.textos.cartaoUnimedWebAlerta }}</p>
        </el-col>
      </el-row>
    </dialog-default>

    <!-- Componente de navegação embed -->
    <EmbedNavigation
      identifier="cartaoVirtual"
      :on-back="onNavigationBack"
      @voltar="$emit('voltar')"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import GrupoFamiliar from '@/components/GrupoFamiliar/GrupoFamiliar'
import { CartaoVirtualResource } from '@/API'
import MenuVertical from '@/components/MenuVertical/MenuVertical'
import DialogoCarencias from '@/views/3/DialogoCarencias'
import CartaoVirtualImpressao from '@/views/3/CartaoVirtualImpressao'
import { html2base64 } from '@/utils/converter'
import { formatPayloadLogin } from '@mobilesaude/frontend_libs/libs/formbuilder/HandlerDataSource'
import { findValueIntoObject } from '@/utils/utils'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import EmbedNavigation from '@/components/FuncionalidadeHeader/EmbedNavigation'

export default {
  name: 'Func3CartaoVirtual',
  components: {
    CartaoVirtualImpressao,
    DialogoCarencias,
    MenuVertical,
    FuncionalidadeHeader,
    GrupoFamiliar,
    DialogDefault,
    EmbedNavigation
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'funcParams']),
    carencias () {
      if (!this.beneficiarioSelecionado || !this.beneficiarioSelecionado.beneficiarioDados) {
        return []
      }

      return this.beneficiarioSelecionado.beneficiarioDados.dadosDoPlano.carencias
    },
    handlerDataSource () {
      return formatPayloadLogin({
        payloadLogin: { ...this.$store.state.Login.usuarioPayload },
        chaveUnica: this.beneficiarioSelecionado.chaveUnica,
        numeroContrato: this.beneficiarioSelecionado.numeroContrato
      })
    }
  },
  watch: {
    beneficiarioSelecionado () {
      this.getCartaoVirtual()
    }
  },
  data () {
    return {
      showDialog: false,
      cartaoImagem: {
        frente: null,
        verso: null
      },
      loaded: false,
      beneficiarioSelecionado: null,
      cartaoData: null,
      mostrarCarencias: false,
      telaPrint: false,
      columnsCarencias: null,
      columnsExport: [
        {
          title: 'Imprimir cartão',
          action: this.cartaoPrint
        }
        /*
        // TODO: 20/10/2021 implementação do pdf
        {
          title: 'Salvar cartão (PDF)',
          action: this.cartaoPdf
        }
        */
      ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.loaded = false
    },
    onNavigationBack () {
      this.showDialog = false
      this.mostrarCarencias = false

      if (this.beneficiarioSelecionado) {
        // Se um beneficiário está selecionado, limpa a seleção
        this.beneficiarioSelecionado = null
        return false
      }
      return true
    },
    // Método para lidar com a ação de voltar (agora delegado ao EmbedNavigation)
    handleVoltar () {
      this.$children.find(child => child.$options.name === 'EmbedNavigation').goBack()
    },
    async mountHTML (data) {
      let html = `<div
                style="height: 265px;width: 450px; border-radius: 15px;position: relative; margin-bottom: 20px;"
                >
                ${data.html}
                </div>
`

      data.variaveis.forEach((variavel) => {
        const searchValue = RegExp(`\\$\\{${variavel.valor}\\}`, 'gi')
        html = html.replace(searchValue, this.aplicaMasccara(variavel.valor, variavel.mascara, variavel.valorPadrao))
      })

      return html
    },
    aplicaMasccara (caminho, mascara, valor = 'N/A') {
      const text = this.getValor(caminho)

      const rgx = /^(\d{4})-(\d{2})-(\d{2})$/
      const rgxData = rgx.exec(text)
      if (rgxData) {
        return `${rgxData[3]}/${rgxData[2]}/${rgxData[1]}`
      }

      if (!mascara) {
        return text === '' ? valor : text
      }

      const maskReplacers = {
        '#': /\d/,
        A: /[a-z]/i,
        N: /[a-z0-9]/i,
        X: /./
      }

      const regexMask = mascara
        .split('')
        .map((char) => maskReplacers[char] || char)

      let valorFinal = ''
      let indexValor = 0
      for (let i = 0; i < regexMask.length; i++) {
        if (typeof regexMask[i] === 'string') {
          valorFinal += regexMask[i]
          continue
        }

        if (text && regexMask[i].test(text[indexValor])) {
          valorFinal += text[indexValor]
          indexValor++
        } else {
          break
        }
      }

      return valorFinal
    },
    getValor (caminho) {
      if (!caminho) {
        return ''
      }
      return findValueIntoObject(this.handlerDataSource, caminho)
    },
    async getCartaoVirtual () {
      if (!this.beneficiarioSelecionado || !this.beneficiarioSelecionado.beneficiarioDados) {
        return
      }
      this.loaded = false
      const loader = this.$loading({
        lock: true,
        fullscreen: true,
        text: '',
        customClass: 'myloading'
      })
      this.cartaoData = await CartaoVirtualResource.carregar(
        this.beneficiarioSelecionado.beneficiarioDados.cartao.modeloCartao
      )

      if (this.cartaoData[0] && this.cartaoData[0].tipo === 2) {
        this.showDialog = true
        this.beneficiarioSelecionado = null
        setTimeout(() => {
          loader.close()
        }, 300)
        return false
      }
      if (this.cartaoData[0] && this.cartaoData[0].utilizarCarencias) {
        this.columnsCarencias = [
          {
            title: 'Ver carências',
            action: this.openCarencias
          }
        ]
      }
      setTimeout(() => {
        this.loaded = true
        loader.close()
      }, 300)
      await this.convertToImage()
    },
    async convertToImage () {
      if (!this.beneficiarioSelecionado || !Array.isArray(this.cartaoData) || this.cartaoData.length === 0) {
        return false
      }

      const cartaoData = this.cartaoData[0]

      const cartao = {
        frente: await this.mountHTML(cartaoData.cartaoVirtual.frente),
        verso: await this.mountHTML(cartaoData.cartaoVirtual.verso)
      }

      this.cartaoImagem.frente = {
        data: await html2base64(cartao.frente),
        background: cartaoData.cartaoVirtual.frente.background
      }
      this.cartaoImagem.verso = {
        data: await html2base64(cartao.verso),
        background: cartaoData.cartaoVirtual.verso.background
      }
      this.loaded = true
    },
    openCarencias () {
      this.mostrarCarencias = true
    },
    cartaoPrint () {
      this.telaPrint = true
      setTimeout(() => {
        window.print()
      }, 1000)
    },
    cartaoPdf () {
    },
    closePrint () {
      this.telaPrint = false
    }
  }
}
</script>
<style scoped>
.cartao {
  height: 265px;
  width: 450px;
  background-size: contain;
  border-radius: 15px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.cartao-container {
  height: 265px;
  width: 450px;
  border-radius: 15px;
  position: relative;
  box-shadow: 0 3px 30px #0000001A;
}
</style>
